import React from 'react'
import { useTranslate } from 'react-admin'
import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'

type Props = {
  accordionText: string[]
  accordionTitle: string
}

const AccordionSuggestion: React.FC<Props> = ({
  accordionText,
  accordionTitle,
  ...props
}) => {
  const translate = useTranslate()
  return (
    <React.Fragment {...props}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <div>{translate(accordionTitle)}</div>
        </AccordionSummary>
        <AccordionDetails>
          {accordionText!.map((e) => (
            <React.Fragment key={e}>
              {translate('form.fields.' + e)}
              <br />
              <br />
            </React.Fragment>
          ))}
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  )
}

export default AccordionSuggestion
